module.exports = __webpack_public_path__ + "static/media/main.0133d556.png";